/* Native cart order labels. Prices, permissions and checkout remain Shopify's responsibility. */
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (!root?.document || root.customElements.get('saber-property-purchasing')) return;
  const document = root.document;
  let state = null, saving = null;
  const widgets = () => [...document.querySelectorAll('saber-property-purchasing')];
  const paint = (message, error = false) => {
    document.querySelectorAll('.cart-dynamic-checkout-buttons').forEach(surface => { surface.inert = Boolean(state?.dirty || saving); surface.setAttribute('aria-disabled',String(Boolean(state?.dirty || saving))); });
    widgets().forEach(widget => {
    if (!state || widget.dataset.scope !== state.scope) return;
    widget.querySelectorAll('[data-purchasing-field]').forEach(field => {
      const value = state.values[field.dataset.purchasingField] || '';
      if (field.value !== value) field.value = value;
    });
    const button = widget.querySelector('[data-purchasing-save]');
    if (button) { button.disabled = Boolean(saving); button.textContent = saving ? 'Saving…' : 'Save order details'; }
    const status = widget.querySelector('[data-purchasing-status]');
    if (status && message) { status.textContent = message; status.setAttribute('role', error ? 'alert' : 'status'); status.classList.toggle('is-error', error); }
    });
  };
  const save = async () => {
    if (saving) { await saving; if (state.dirty) return save(); return; }
    if (!state || !state.dirty) return;
    const requested = {...state.values, [api.CONTEXT]: state.scope};
    const revision = state.revision;
    const endpoint = new URL('cart/update.js', new URL(state.root, root.location.origin));
    if (endpoint.origin !== root.location.origin) throw new Error('The cart address could not be verified. Refresh and try again.');
    saving = (async () => {
      const controller = new AbortController();
      const timeout = root.setTimeout(() => controller.abort(), 15000);
      try {
        const response = await root.fetch(endpoint.href, {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({attributes:requested}),signal:controller.signal});
        const cart = await response.json();
        if (!response.ok || !api.matches(cart.attributes, requested)) throw new Error('Your order details were not saved. Please try again before checking out.');
        if (state.revision === revision) state.dirty = false;
        document.dispatchEvent(new CustomEvent('saber:purchasing-saved', {detail:{attributes:requested}}));
      } catch(error) {
        throw new Error(error.name === 'AbortError' ? 'Saving took too long. Please try again before checking out.' : error.message || 'Your order details could not be saved.');
      } finally { root.clearTimeout(timeout); }
    })();
    paint('Saving order details…');
    try { await saving; }
    finally { saving = null; paint(); }
    if (state.dirty) return save();
    paint('Order details saved to your cart.');
  };
  class PurchasingCenter extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      let initial; try {initial = JSON.parse(this.dataset.initial || '{}');} catch {initial = {};}
      if (!state || state.scope !== this.dataset.scope) state = {scope:this.dataset.scope,root:this.dataset.rootUrl || '/',values:api.values(initial),revision:0,dirty:Boolean(initial[api.CONTEXT] && initial[api.CONTEXT] !== this.dataset.scope)};
      this.addEventListener('input', event => {
        const field = event.target.closest('[data-purchasing-field]'); if (!field) return;
        state.values[field.dataset.purchasingField] = field.value.slice(0,100);
        state.revision++; state.dirty = true; paint('Unsaved changes. Save these details before ordering.');
      });
      this.querySelector('[data-purchasing-save]')?.addEventListener('click', async () => {
        state.dirty = true;
        try {await save();} catch(error) {paint(error.message,true);}
      });
      paint(state.dirty ? 'Previous account labels have been cleared. Save to update this cart.' : null);
      const outerForm = this.closest('form');
      if (outerForm) outerForm.dataset.purchasingCart = 'true';
    }
  }
  root.customElements.define('saber-property-purchasing', PurchasingCenter);
  const checkedForms = new WeakSet();
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof root.HTMLFormElement)) return;
    if (checkedForms.has(form)) {checkedForms.delete(form);return;}
    const submitter = event.submitter;
    const checkout = submitter?.name === 'checkout' || form.matches('[data-purchasing-cart]');
    if (!checkout || !state || !state.dirty) return;
    event.preventDefault();event.stopImmediatePropagation();
    try {
      await save();
      if (!form.isConnected) throw new Error('The cart refreshed. Review your saved details and select checkout again.');
      checkedForms.add(form);
      if (submitter?.isConnected) form.requestSubmit(submitter); else form.requestSubmit();
    } catch(error) {paint(error.message,true); const widget=widgets().find(w=>w.offsetParent!==null);if(widget){widget.querySelector('details').open=true;widget.querySelector('[data-purchasing-status]')?.scrollIntoView({block:'nearest'});}}
  }, true);
  document.addEventListener('click', async event => {
    const link = event.target.closest('a[href]');
    if (!link || !state?.dirty) return;
    const url = new URL(link.href,root.location.href);
    if (url.origin !== root.location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?checkout(?:\/|$)/i.test(url.pathname)) return;
    event.preventDefault();event.stopImmediatePropagation();
    try {await save();root.location.assign(url.href);} catch(error) {paint(error.message,true);}
  }, true);
})(typeof window === 'undefined' ? null : window, function () {
  const FIELDS=Object.freeze(['Property name','Building','Apartment / unit','PO reference']);
  const CONTEXT='_Saber purchasing context';
  const values=input=>Object.fromEntries(FIELDS.map(key=>[key,String(input?.[key]||'').slice(0,100)]));
  const matches=(actual,requested)=>[...FIELDS,CONTEXT].every(key=>String(actual?.[key]||'')===String(requested[key]||''));
  return Object.freeze({FIELDS,CONTEXT,values,matches});
});
